import { render } from "./RedefinirSenha.vue?vue&type=template&id=672e19c5&scoped=true"
import script from "./RedefinirSenha.vue?vue&type=script&lang=js"
export * from "./RedefinirSenha.vue?vue&type=script&lang=js"

import "./RedefinirSenha.vue?vue&type=style&index=0&id=672e19c5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672e19c5"]])

export default __exports__